import { LoginService } from './../../service/login.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.scss']
})
export class ForgetPasswordComponent implements OnInit {
  phone:number;
  msg:string="Please Enter Valid phone No";
  user:any;
  addForm:FormGroup;
  constructor(private route:Router,private ApiService:LoginService, private fb:FormBuilder) {
    this.addForm=fb.group({
      'phone':[null,Validators.compose([Validators.required,Validators.minLength(10),Validators.maxLength(40)])]
    })
   }
  
  ngOnInit(): void {
    this.getPhone()
  }
  getPhone():void
  {
   this.ApiService.getUser().then(
     data=>(this.user=data)
     
   );
  }
  verify(phone)
  {
    for(let user of Object.keys(this.user))
    {
      var phn=this.user[user]
      if(phn.phone==phone.phone)
      {
        console.log(phn);
        localStorage.setItem('idr', phn.id);
      console.log("phone no is Correct");
      this.route.navigateByUrl('forgetPassword/otp');
      }
    }
  }
   otp()
  {
    this.route.navigateByUrl('forgetPassword/otp');
  }
}
